import React from "react";
import PropTypes from "prop-types";

export default function FilterChip({ label, onRemove }) {
  return (
    <span
      className="badge rounded-pill d-inline-flex align-items-center gap-1 me-1"
      style={{ background: "#e8f0fe", color: "#1a56db", fontSize: 12, fontWeight: 500 }}
    >
      {label}
      <button
        type="button"
        className="btn-close btn-close"
        style={{ fontSize: 9, filter: "invert(30%) sepia(80%) saturate(300%) hue-rotate(190deg)" }}
        aria-label="Remove filter"
        onClick={onRemove}
      />
    </span>
  );
}

FilterChip.propTypes = {
  label:    PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
};
